import { MsalProvider } from '@azure/msal-react';
import { Layout } from '@organisms/Layout';
import { initGA, logPageView, msalInstance } from '@utils';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from 'react-router-dom';
import {
  BeforeYouStart,
  DescribeTheIssue,
  IssueSelection,
  ReportToStreetLightsTeam,
  UploadPhoto,
  IssueLocation,
  LocationAdditionalInformation,
  EmailConfirmation,
  ContactUserOption,
  YourDetails,
  Confirmation,
} from './components/pages';
import { RoutesList, steps } from '../routes/Routes';
import { basename } from '../routes/basename';
import { useEffect } from 'react';
import { useScrollToTop } from '@shared/hooks';

function App() {
  useEffect(() => {
    initGA();
    logPageView();

    // Log page views on route change
    const logPageViewOnRouteChange = () => logPageView();
    window.addEventListener('popstate', logPageViewOnRouteChange);

    return () =>
      window.removeEventListener('popstate', logPageViewOnRouteChange);
  }, []);
  // It's important that the Router component is above the pages component because you'll need to use the useHistory hook before rendering MsalProvider
  return (
    <Router basename={basename}>
      <RouteChangeTracker />
      <Pages />
    </Router>
  );
}

function Pages() {
  useScrollToTop();

  return (
    <MsalProvider instance={msalInstance}>
      <Layout steps={steps}>
        <Routes>
          <Route path={'/'} element={<BeforeYouStart />} />
          <Route
            path={RoutesList.SIGNS_BOLLARDS_HOME}
            element={<BeforeYouStart />}
          />
          <Route path={RoutesList.ISSUE_TYPE} element={<IssueSelection />} />
          <Route
            path={RoutesList.DESCRIBE_ISSUE}
            element={<DescribeTheIssue />}
          />
          <Route
            path={RoutesList.REPORT_ISSUE_TO_STREETLIGHTS_TEAM}
            element={<ReportToStreetLightsTeam />}
          />
          <Route path={RoutesList.UPLOAD_PHOTO} element={<UploadPhoto />} />
          <Route path={RoutesList.ISSUE_LOCATION} element={<IssueLocation />} />
          <Route
            path={RoutesList.LOCATION_ADDITIONAL_INFORMATION}
            element={<LocationAdditionalInformation />}
          />
          <Route
            path={RoutesList.EMAIL_CONFIRMATION}
            element={<EmailConfirmation />}
          />
          <Route
            path={RoutesList.CONTACT_USER_OPTION}
            element={<ContactUserOption />}
          />
          <Route path={RoutesList.YOUR_DETAILS} element={<YourDetails />} />
          <Route path={RoutesList.CONFIRMATION} element={<Confirmation />} />
        </Routes>
      </Layout>
    </MsalProvider>
  );
}

export const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return null;
};
export default App;
